<template>
  <div class="hello">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title text-left">{{ guessData.question_name }}</h5>
        <img v-if="guessData.file_info&&guessData.file_info.length>0" :src="guessData.file_info[0].url"
          class="card-img-top" alt="" />
        <p class="card-text text-left mt-3" v-html="guessData.question_option"></p>
        <p @click="guess_show = true" v-show="!guess_show">点击此处获取答案</p>
        <p v-html="guessData.answer" class="text-left" v-show="guess_show"></p>
        <p v-html="guessData.explain" class="text-left" v-show="guess_show"></p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Guess",
    props: {
      guessId: Number,
      articleId: Number,
    },
    data() {
      return {
        guess: {},
        guess_show: false,

        guessData: '',
      };
    },
    mounted() {

      this.getguess()
    },
    methods: {
      getguess() {
        let that = this

        axios.post("/admin/PictureQuestion/questionRead", {
            id: this.guessId
          }, {
            token: true
          })
          .then(response => {
            this.guessData = response.data.data

          })
          .catch(error => {})
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h3 {
    margin: 40px 0 0;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>